export enum OrderItemViewType {
  Active = 'Active',
  Historic = 'Historic',
  OnHold = 'OnHold'
}
